import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AsociacionesService } from './api/asociaciones.service';
import { AsociadosService } from './api/asociados.service';
import { AutentificacionService } from './api/autentificacion.service';
import { CargosService } from './api/cargos.service';
import { EjerciciosService } from './api/ejercicios.service';
import { HistoricoService } from './api/historico.service';
import { TipoAsociacionesService } from './api/tipoAsociaciones.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AsociacionesService,
    AsociadosService,
    AutentificacionService,
    CargosService,
    EjerciciosService,
    HistoricoService,
    TipoAsociacionesService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
